import Vue from 'vue'
import Router from 'vue-router'
import indexView from '@/views/index/index'
import aboutUs from '@/views/aboutUs/aboutUs'
import course from '@/views/course/course'
import newsInformation from '@/views/newsInformation/newsInformation'
import newsDetail from '@/views/newsDetail/newsDetail'
import contactUs from '@/views/contactUs/contactUs'
import recruitment from '@/views/recruitment/recruitment'
import jobDetail from '@/views/recruitment/jobDetail'
import business from '@/views/business/business'
import businessDetail from '@/views/business/businessDetail'

// 解决重复点击报错bug
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
}
Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'indexView',
            component: indexView
        },{
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs
        },
        //  {
        //     path: '/course',
        //     name: 'course',
        //     component: course
        // },
         {
            path: '/newsInformation',
            name: 'newsInformation',
            component: newsInformation
        }, {
            path: '/newsDetail/:id',
            name: 'newsDetail',
            component: newsDetail
        }, {
            path: '/contactUs',
            name: 'contactUs',
            component: contactUs
        }, {
            path: '/business',
            name: 'business',
            component: business
        }, {
            path: '/business/detail/:index',
            name: 'businessDetail',
            component: businessDetail
        }, {
            path: '/recruitment',
            name: 'recruitment',
            component: recruitment
        }, {
            path: '/recruitment/detail/:id',
            name: 'jobDetail',
            component: jobDetail
        }
    ],
    mode: 'history',
})

export default router


// 跳转后自动返回页面顶部
router.afterEach(() => {
    window.scrollTo(0, 0);
})
